import { render, staticRenderFns } from "./TabBar.vue?vue&type=template&id=32f6562c&scoped=true"
import script from "./TabBar.vue?vue&type=script&lang=ts"
export * from "./TabBar.vue?vue&type=script&lang=ts"
import style0 from "./TabBar.vue?vue&type=style&index=0&id=32f6562c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f6562c",
  null
  
)

export default component.exports